import {ActionContext, ActionTree} from "vuex";
import {RootState} from "@/store/state";
import {StatisticsScreenState} from "@/modules/statistics/store/state";
import {log} from "@/core/logger";
import {GET} from "@/core/http/methods";
import {StatisticsMutations} from "@/modules/statistics/store/mutations";

type Context = ActionContext<StatisticsScreenState, RootState>;

export enum StatisticsActions {
  FETCH_STATISTICS = "FETCH_STATISTICS",
}

const actions: ActionTree<StatisticsScreenState, RootState> = {
  async [StatisticsActions.FETCH_STATISTICS](context: Context
  ): Promise<void> {
    try {
      log(`attempting to fetch statistics`);
      context.commit(StatisticsMutations.SET_LOADING);
      const response = await GET("statistics/alerts");
      log(`successfully fetched statistics`);
      context.commit(StatisticsMutations.SET_NOT_LOADING);
      return await context.commit(StatisticsMutations.SET_STATISTICS,
        {
          items: response.data.items
        });
    } catch (error: any) {
      log(`failed to fetch statistics.`, error);
      context.commit(StatisticsMutations.SET_NOT_LOADING);
      return context.commit(StatisticsMutations.SET_ERROR,
        {
          error: error.response.data.err
        });
    }
  },
};

export default actions;

